module.exports = __webpack_public_path__ + "static/fonts/iconfont.7fe3436.woff";